import axios from '@/request/axios'
import { agent } from '@/request/api'

const state = {
  list: []
}

const mutations = {
}

const actions = {
  //  结算列表
  list ({}, data) {
    return axios.postFromDataRequest(agent.settlement, data)
  },
  //  审核结算
  review ({}, data) {
    return axios.postFromDataRequest(agent.review, data)
  },
  //  结算详情
  detail ({}, data) {
    return axios.postFromDataRequest(agent.settlementDetail, data)
  },
  add ({}, data) {
    return axios.postFromDataRequest(agent.addSettlement, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/settlement.js